import { useEffect } from 'react';
import { useAuth } from '../../Contexts/AuthContext';
import { sendDataToGTM } from '../../Utils/analytics/googleTagManager';

function GAUserId() {
  const { userInfo } = useAuth();

  useEffect(() => {
    const user_id = userInfo?.id ?? null;
    sendDataToGTM({ user_id });
  }, [userInfo]);

  return null;
}

export default GAUserId;
